import type { PublicSignatureStatusResponse, PublicSigningUrlResponse } from "@repo/shared/types";
import { get } from "../_client";

/**
 * The eID sign page's (`/p/:token/sign`) first call: the Criipto signing URL,
 * plus the flow's `language` so the page renders in it (QL-17 issue 027).
 */
export function getSigningUrl(signToken: string) {
  return get<PublicSigningUrlResponse>(`/public/signatures/${signToken}/signing-url`);
}

export function getSignatureStatus(signToken: string) {
  return get<PublicSignatureStatusResponse>(`/public/signatures/${signToken}/status`);
}
